export const DashboardPage = () =>
  import(/* webpackChunkName: "core-module" */ "@/views/Dashboard.vue");
export const HelpPage = () =>
  import(/* webpackChunkName: "core-module" */ "@/views/Help.vue");
export const AccountLayoutPage = () =>
  import(/* webpackChunkName: "core-module" */ "@/views/account/Layout.vue");
export const AccountHistoryPage = () =>
  import(/* webpackChunkName: "core-module" */ "@/views/account/History.vue");
export const AccountSecurityPage = () =>
  import(/* webpackChunkName: "core-module" */ "@/views/account/Security.vue");
export const AccountProfilePage = () =>
  import(/* webpackChunkName: "core-module" */ "@/views/account/Profile.vue");

export function registerCoreModule(r: any): any {
  if (r.length > 0 && r[0].children) {
    r[0].children = r[0].children.concat(
      {
        path: "",
        redirect: "/dashboard"
      },
      {
        path: "/dashboard",
        component: DashboardPage
      },
      {
        path: "/help",
        component: HelpPage
      },
      {
        path: "/account",
        component: AccountLayoutPage,
        children: [
          {
            path: "",
            redirect: "/profile"
          },
          {
            path: "profile",
            component: AccountProfilePage
          },
          {
            path: "history",
            component: AccountHistoryPage
          },
          {
            path: "security",
            component: AccountSecurityPage
          }
        ]
      }
    );
  }
  return r;
}
